import React, { useState } from 'react';
import { useAppToast } from '../../helpers/lib/useAppToast';

const CONTACT_EMAIL = 'contact@noohraservices.org';
const EMPTY_FORM = { name: '', email: '', subject: '', message: '' };

/**
 * There is no contact endpoint on the API, so submitting opens the visitor's email app
 * with the message pre-filled and addressed to the Noohra inbox.
 */
export default function ContactForm() {
  const toast = useAppToast();
  const [form, setForm] = useState(EMPTY_FORM);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast({ status: 'error', description: 'Please enter your name, email and message.' });
      return;
    }

    const subject = form.subject.trim() || `Message from ${form.name.trim()}`;
    const body = `${form.message.trim()}\n\n— ${form.name.trim()} (${form.email.trim()})`;
    window.location.href =
      `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    toast({
      status: 'info',
      description: `Your email app should open with your message. If it doesn't, write to us at ${CONTACT_EMAIL}.`,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
      <div className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color" htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            className="cs_form_field"
            placeholder="David John"
            value={form.name}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color" htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            className="cs_form_field"
            placeholder="example@gmail.com"
            value={form.email}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color" htmlFor="contact-subject">Subject</label>
          <input
            id="contact-subject"
            name="subject"
            type="text"
            className="cs_form_field"
            placeholder="Your subject"
            value={form.subject}
            onChange={handleChange}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color" htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            name="message"
            cols={30}
            rows={10}
            className="cs_form_field"
            placeholder="Write something..."
            value={form.message}
            onChange={handleChange}
            required
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <div className="cs_height_18" />
          <button type="submit" className="cs_btn cs_style_1">
            <span>Submit</span>
            <i>
              <img src="/images/icons/arrow_white.svg" alt="" />
              <img src="/images/icons/arrow_white.svg" alt="" />
            </i>
          </button>
        </div>
      </div>
    </form>
  );
}
